import * as React from "react";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { Checkbox, TextField } from "@mui/material";

const OrderFilters = ({ onFilterChange, filters }) => {
  const handleFilterChange = (field, value) => {
    const newFilters = { ...filters, [field]: value };
    onFilterChange?.(newFilters);
  };

  return (
    <div className="flex items-center gap-4 flex-wrap">
      {/* Status Filter */}
      <FormControl size="small" sx={{ minWidth: 180 }}>
        <InputLabel>Status</InputLabel>
        <Select
          value={filters.status}
          label="Status"
          onChange={e => handleFilterChange("status", e.target.value)}
          sx={{
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#E5E7EB",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "#5652B0",
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "#5652B0",
            },
          }}>
          <MenuItem value="">All</MenuItem>
          <MenuItem value="Pending">Pending</MenuItem>
          <MenuItem value="Approved">Approved</MenuItem>
          <MenuItem value="Rejected">Rejected</MenuItem>
        </Select>
      </FormControl>

      {/* Date Range Filter */}
      <FormControl size="small" sx={{ minWidth: 180 }}>
        <InputLabel>Date Range</InputLabel>
        <Select
          value={filters.dateRange}
          label="Date Range"
          onChange={e => handleFilterChange("dateRange", e.target.value)}
          sx={{
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#E5E7EB",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "#5652B0",
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "#5652B0",
            },
          }}>
          <MenuItem value="">All</MenuItem>
          <MenuItem value="today">Today</MenuItem>
          <MenuItem value="yesterday">Yesterday</MenuItem>
          <MenuItem value="lastWeek">Last Week</MenuItem>
          <MenuItem value="lastMonth">Last Month</MenuItem>
          <MenuItem value="lastQuarter">Last Quarter</MenuItem>
        </Select>
      </FormControl>

      {/* Amount Filter */}
      <FormControl size="small" sx={{ minWidth: 180 }}>
        <InputLabel>Amount</InputLabel>
        <Select
          value={filters.amount}
          label="Amount"
          onChange={e => handleFilterChange("amount", e.target.value)}
          sx={{
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#E5E7EB",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "#5652B0",
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "#5652B0",
            },
          }}>
          <MenuItem value="">All</MenuItem>
          <MenuItem value="0-10000">₹0 - ₹10,000</MenuItem>
          <MenuItem value="10000-50000">₹10,000 - ₹50,000</MenuItem>
          <MenuItem value="50000-100000">₹50,000 - ₹100,000</MenuItem>
          <MenuItem value="100000+">Above ₹100,000</MenuItem>
        </Select>
      </FormControl>

      {/* Sort By Filter */}
      <FormControl size="small" sx={{ minWidth: 180 }}>
        <InputLabel>Sort By</InputLabel>
        <Select
          value={filters.sortBy}
          label="Sort By"
          onChange={e => handleFilterChange("sortBy", e.target.value)}
          sx={{
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#E5E7EB",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "#5652B0",
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "#5652B0",
            },
          }}>
          <MenuItem value="">None</MenuItem>
          <MenuItem value="firmName_asc">Firm Name (A-Z)</MenuItem>
          <MenuItem value="firmName_desc">Firm Name (Z-A)</MenuItem>
          <MenuItem value="amount_asc">Amount (Low-High)</MenuItem>
          <MenuItem value="amount_desc">Amount (High-Low)</MenuItem>
          <MenuItem value="date_desc">Newest First</MenuItem>
          <MenuItem value="date_asc">Oldest First</MenuItem>
        </Select>
      </FormControl>
    </div>
  );
};

export default OrderFilters;
